import { useIntl } from 'react-intl';
import React, { FC } from 'react';
import { LanguageProvider } from '@cld/intl';
import EmptyState, { CommonEmptyStateProps } from '../../EmptyState';
import { loadMessages, messages } from '../../i18n';
import serverError from './serverError.svg';

type ServerErrorProps = CommonEmptyStateProps;

export const ServerError: FC<ServerErrorProps> = ({ ...rest }) => {
  const { formatMessage } = useIntl();
  return <EmptyState imageSrc={serverError} imageHeight={134} imageWidth={148} title={formatMessage(messages.serverErrorTitle)} {...rest} />;
};

const ServerErrorIntl: FC<ServerErrorProps> = (props) => (
  <LanguageProvider loadMessages={loadMessages}>
    <ServerError {...props} />
  </LanguageProvider>
);

export default ServerErrorIntl;
